import React, { useState, useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import modalStyles from '../../styles/modals.module.css';

const NewUserModal = ({ onClose, onSubmitRef }) => {
  const [projectCode, setProjectCode] = useState('');
  const [showProjectCodeInput, setShowProjectCodeInput] = useState(false);
  const [error, setError] = useState('');
  const navigate = useNavigate();

  const handleCreateProject = () => {
    // Close this modal and navigate to the onboarding wizard
    if (onClose) onClose();
    navigate('/wizard');
  };

  const handleJoinProject = async () => {
    if (!showProjectCodeInput) {
      setShowProjectCodeInput(true);
      return;
    }

    // Project joining logic will be implemented later
    setError('הצטרפות לפרויקט תהיה זמינה בקרוב');
  };

  const handleProjectCodeChange = event => {
    setProjectCode(event.target.value);
    setError(''); // Clear any previous errors
  };

  // Set submit ref for keyboard support
  useEffect(() => {
    if (onSubmitRef) {
      onSubmitRef(handleCreateProject);
    }
  }, [onSubmitRef]);

  return (
    <div className={modalStyles.modal} dir="rtl">
      <div className={modalStyles.header}>
        <h2 className={modalStyles.headerTitle}>ברוכים הבאים!</h2>
        <p className={modalStyles.headerSubtitle}>בחרו כיצד להתחיל</p>
      </div>

      <div className={modalStyles.content}>
        <p className={modalStyles.info}>
          כדי להתחיל, תוכלו ליצור פרויקט חדש או להצטרף לפרויקט קיים
        </p>

        <div className={modalStyles.formGrid}>
          <button className={modalStyles.primaryButton} onClick={handleCreateProject}>
            צור פרויקט חדש
          </button>

          <button className={modalStyles.secondaryButton} onClick={handleJoinProject}>
            {showProjectCodeInput ? 'הצטרף לפרויקט' : 'הצטרף לפרויקט קיים'}
          </button>

          {showProjectCodeInput && (
            <div className={modalStyles.field}>
              <label className={modalStyles.fieldLabel}>קוד פרויקט</label>
              <input
                className={modalStyles.fieldInput}
                value={projectCode}
                onChange={handleProjectCodeChange}
              />
              {error && <div className={modalStyles.fieldError}>{error}</div>}
            </div>
          )}
        </div>
      </div>
    </div>
  );
};

export default NewUserModal;
